import { useContext } from 'react';

import { ReviewContext } from '../context/ReviewContext';

export const useReviewContext = () => {
  const context = useContext(ReviewContext);

  if (!context)
    throw new Error(
      'useReviewContext needs to be used within ReviewContext.Provider!'
    );

  return context;
};
